<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteSettingsGeneral from '../../../../../sites/components/SiteSettingsGeneral.vue'

import { Site } from '../../../../../sites/models/site.ts'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { site } = defineProps<{
  site: Site
}>()
</script>

<template>
  <SiteSettingsGeneral :site="site" />
</template>
